const headerDataDespatch = [
  {
    prop: "InvAddCode",
    label: "型号",
    columnwidth: 120,
  },
  {
    prop: "VouCode",
    label: "经销商出库单号",
    columnwidth: 150,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 60,
  },
  {
    prop: "DPDate",
    label: "出库日期",
    columnwidth: 160,
  },
  {
    prop: "ObjName",
    label: "客户名称",
    columnwidth: 220,
  },
  {
    prop: "VoucherType",
    label: "单据类型",
    columnwidth: 100,
  },
  {
    prop: "WHName",
    label: "仓库名称",
    columnwidth: 230,
  },
  {
    prop: "Total",
    label: "出库金额",
    columnwidth: 100,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 230,
  },
  {
    prop: "Creator",
    label: "创建人",
    columnwidth: 100,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 160,
  },
  {
    prop: "Verifier",
    label: "审核人",
    columnwidth: 100,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 160,
  },
];

export default headerDataDespatch;
